import { service } from '@ember/service';
import Route from '@ember/routing/route';

export default class SiteBillingPendingInsuranceShowRoute extends Route {
  @service store;

  async model(params) {
    const client = this.modelFor('site.billing.pending-insurance');

    // Find the review directly by matching the insurance connection ID
    const pendingReview = this.store
      .peekAll('clinician-insurance-info-review')
      .find(
        review =>
          review.status === 'pending' && review.insuranceInfoRequestConnection?.id === params.id
      );

    if (!pendingReview) {
      return this.router.transitionTo('site.billing.insurance');
    }

    return { client, insuranceInfoRequestConnection: pendingReview.insuranceInfoRequestConnection };
  }
}
